/* __next_internal_client_entry_do_not_use__ MaybeAssignHubsRSCM1Setting auto */ import { useAssignSettingLoggedInHubsRSCM1 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedInHubsRSCM1";
import { useEffect } from "react";
export var MaybeAssignHubsRSCM1Setting = function(param) {
    var isHubsCategory = param.isHubsCategory;
    var assignHubsRSCSetting = useAssignSettingLoggedInHubsRSCM1();
    useEffect(function() {
        if (isHubsCategory) {
            assignHubsRSCSetting();
        }
    }, [
        assignHubsRSCSetting,
        isHubsCategory
    ]);
    return null;
};
